@if ((site$ | async); as site) {
  <div class="container">
    <div class="left">
      @if (!(advancedFeaturesAvailable$ | async) && !(advancedFeaturesActivating$ | async)) {
        <button
          mat-button="filled"
          class="activate-item"
          [disabled]="isRequestingAdvancedFeaturesActivation"
          (click)="activate(site)">
          <mat-icon>design_services</mat-icon>
          <span>{{'activate_advanced_features' | transloco}}</span>
        </button>
      }

    @if ((advancedFeaturesAvailable$ | async)&& !(advancedFeaturesActivating$ | async)) {
      <div
        class="advanced-features-activating">
        {{'advanced_features_activated_until' | transloco: {'date': ((advancedFeaturesExpirationDate$ | async) | date:'HH:mm')} }}
      </div>
    }
    @if (!(advancedFeaturesAvailable$ | async) && (advancedFeaturesActivating$ | async)) {
      <div
        class="advanced-features-activating">
        <div>{{'advanced_features_activating' | transloco}}</div>
        <div>
          @if (site.status === siteStatus.INSTANCE_CREATING) {
            <mat-icon>clock_loader_10</mat-icon>
          }
          @if (site.status === siteStatus.INSTANCE_CREATED) {
            <mat-icon>clock_loader_20</mat-icon>
          }
          @if (site.status === siteStatus.INSTANCE_CONFIGURING) {
            <mat-icon>clock_loader_40</mat-icon>
          }
          @if (site.status === siteStatus.SERVICE_STARTING) {
            <mat-icon>clock_loader_60</mat-icon>
          }
          @if (site.status === siteStatus.SERVICE_CONFIGURED) {
            <mat-icon>clock_loader_80</mat-icon>
          }
          @if (site.status === siteStatus.INITIALIZING) {
            <mat-icon>clock_loader_90</mat-icon>
          }
        </div>
      </div>
    }
  </div>
  <div class="right">
    <button mat-icon-button
      [matTooltip]="'more' | transloco"
      [matMenuTriggerFor]="moreMenu">
      more_horiz
    </button>
    <input type="file"
      class="file-input"
      onclick="this.value = null"
      (change)="onFileSelected($event)" #fileUpload>
    <mat-menu #moreMenu="matMenu">
      @if (!(advancedFeaturesAvailable$ | async)) {
        <div
          class="advanced-features-message">
          {{'advanced_features_required' | transloco}}
        </div>
      }
      <button mat-menu-item
        (click)="onClickUploadCSVCut(site)"
        [disabled]="!(advancedFeaturesAvailable$ | async)">
        <mat-icon>upload</mat-icon>
        <span>{{'upload_cvs_cut' | transloco}}</span>
      </button>
      <button mat-menu-item (click)="onClickUploadCSVElevation(site)"
        [disabled]="!(advancedFeaturesAvailable$ | async)">
        <mat-icon>upload</mat-icon>
        <span>{{'upload_cvs_elevation' | transloco}}</span>
      </button>
      <!--
      <button mat-menu-item (click)="onClickUploadCSVMarker(site)"
        [disabled]="!(advancedFeaturesAvailable$ | async)">
        <mat-icon>upload</mat-icon>
        <span>{{'upload_cvs_marker' | transloco}}</span>
      </button>
      -->
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onClickDownloadPointCloudDense(site)">
        <mat-icon>file_save</mat-icon>
        <span>{{'download_point_cloud_dense' | transloco}}</span>
      </button>
      <button mat-menu-item (click)="onClickDownloadPointCloudSparse(site)">
        <mat-icon>file_save</mat-icon>
        <span>{{'download_point_cloud_sparse' | transloco}}</span>
      </button>

      @if ((user$ | async); as user) {
        @if ((organization$ | async); as organization) {
          @if (canAccessSettings(user, organization)) {

            <mat-divider></mat-divider>

            <button
              mat-menu-item
              (click)="onClickSettings(site, user, organization)">
              <mat-icon>settings</mat-icon>
              <span>{{ 'site_settings' | transloco }}</span>
            </button>

          }
        }
      }

    </mat-menu>
  </div>
</div>
}
